import {provideCartGallery} from '@pages/gallery/gallery.providers'
import {CustomOrganizationThemeGuard} from '@services/guards/custom-organization-theme-guard.service'

export const catalogPage = {
  path: 'catalog',
  // resolve: {categories: categoriesResolver},
  loadComponent: () => import('@pages/catalog/catalog-tabs/catalog-tabs-page.component').then(m => m.CatalogTabsPage),
}

export const contactInfoPage = {
  path: 'contact-info',
  loadComponent: () => import('@pages/customer-area/customer-area.page').then(m => m.CustomerAreaPage),
}

export const dashboardPage = {
  path: 'dashboard',
  loadComponent: () => import('@pages/dashboard/dashboard.page').then(m => m.DashboardPage),
  canActivate: [CustomOrganizationThemeGuard],
}

export const orderListPage = {
  path: 'orders/list',
  loadComponent: () => import('@pages/order-history/order-history.page').then(m => m.OrderHistoryPage),
  canActivate: [CustomOrganizationThemeGuard],
}

export const documentListPage = {
  path: 'documents',
  loadComponent: () => import('@pages/documents-list/documents-list.page').then(m => m.DocumentsListPage),
  canActivate: [CustomOrganizationThemeGuard],
}
export const galleryPage = {
  path: 'gallery',
  loadComponent: () => import('@pages/gallery/gallery.page').then(m => m.GalleryPage),
  providers: [provideCartGallery()],
  canActivate: [CustomOrganizationThemeGuard],
}

export const orderDetailPage = {
  path: 'order/:id',
  name: 'orderDetail',
  loadComponent: () => import('@pages/order-detail/order-detail.component').then(m => m.OrderDetailComponent),
  canActivate: [CustomOrganizationThemeGuard],
}

export const productDetailPage = {
  path: 'product/:id',
  loadComponent: () => import('@pages/catalog/product/product.page').then(m => m.ProductPage),
  canActivate: [CustomOrganizationThemeGuard],
}

export const shareEntityPage = {
  path: 'share/:entityType/:entityId',
  loadComponent: () => import('@pages/share-entity/share-entity-page.component').then(m => m.ShareEntityPage),
  canActivate: [CustomOrganizationThemeGuard],
}

export const cartInfoPage = {
  path: 'cart-info',
  loadComponent: () => import('@pages/cart-info/cart-info.component').then(m => m.CartInfoComponent),
}

export const deliveryInfoConfirmationPage = {
  path: 'delivery-info-confirmation',
  loadComponent: () =>
    import('@pages/delivery-info-confirmation/delivery-info-confirmation.page').then(
      m => m.DeliveryInfoConfirmationPage
    ),
}

export const editCheckoutAddressPage = {
  path: 'edit-checkout-address',
  loadComponent: () =>
    import('@pages/edit-checkout-address/edit-checkout-address.page').then(m => m.EditCheckoutAddressPage),
}

export const addressInfoPage = {
  path: 'address-info',
  loadComponent: () => import('@pages/address-info-page/address-info-page.page').then(m => m.AddressInfoPagePage),
}

export const paymentMethodsPage = {
  path: 'payment-methods',
  loadComponent: () => import('@pages/payment-methods/payment-methods.page').then(m => m.PaymentMethodsPage),
  canActivate: [CustomOrganizationThemeGuard],
}

export const adyenCheckoutPage = {
  path: 'adyen-checkout',
  loadComponent: () => import('@pages/checkout/adyen-checkout/adyen-checkout.page').then(m => m.AdyenCheckoutPage),
  canActivate: [CustomOrganizationThemeGuard],
}

export const packDetailPage = {
  path: 'pack/:packId',
  loadComponent: () => import('@pages/pack-detail/pack-detail.page').then(m => m.PackDetailPage),
}
